var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.987549C6.6125 0.987549 2.1125 4.88755 1.175 10H2.2C3.1125 5.43755 7.1625 1.98755 12 1.98755C17.525 1.98755 22.0125 6.47505 22.0125 12C22.0125 17.525 17.525 22.0126 12 22.0126C6.65 22.0126 2.2625 17.7875 2 12.5H13.1875L10.6625 15.025L11.375 15.7375L14.75 12.3625C14.95 12.1625 14.95 11.85 14.75 11.65L11.375 8.27505L10.6625 8.98755L13.1875 11.5H1C0.987503 11.6625 0.987503 11.8375 0.987503 12C0.987503 18.075 5.925 23.0126 12 23.0126C18.075 23.0126 23.0125 18.075 23.0125 12C23.0125 5.92505 18.0625 0.987549 12 0.987549Z",
    fill: "#00A6CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileIcon);
export default __webpack_public_path__ + "static/media/tile-icon.8da068f2834cb26ac85a950826ba0314.svg";
export { ForwardRef as ReactComponent };